import { nosidEnv } from '@nosinovacao/nosid-mfe-common';
import { type PortalConfiguration } from './models';

export const env = nosidEnv as PortalConfiguration;
